import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import { Submission } from "./Submission";
import { ISubmittals } from "../../models/Submittals";
import { Fetch } from "../../shared/Fetch";
// import { ISubmittals } from "../../../models/Submittals";
// import { Fetch } from "../../../shared/Fetch";

interface Iprops {
    req_id?: number,
    job_Title?: string,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const SubmissionsTable = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<ISubmittals>, loading: boolean });
    const [submission, setSubmission] = useState({ open: false } as {
        recruiter?: string,
        submission_id?: number,
        req_id?: number,
        cons_id?: number,
        vendor_Company_ID?: number,
        status?: number,
        open: boolean
    });
    const hideSubmissionDialog = () => {
        setSubmission({
            recruiter: undefined,
            req_id: undefined,
            cons_id: undefined,
            status: undefined,
            open: false
        });
    };

    const loadTableData = async () => {
        setTableData({ tableData: [], loading: true });
        const response = await Fetch("ECI/allSubmitals", "GET", null, `req_id=${props.req_id}`, props.toast);
        if (response) {
            const data: Array<ISubmittals> = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: [], loading: false });
    }

    useEffect(() => {
        if (props.req_id) loadTableData();
    }, [props.req_id]);

    const submission_id = (rowData: ISubmittals) => {
        return <div className='cursor-pointer text-cyan-700 underline' onClick={() => setSubmission({
            open: true, submission_id: rowData.submission_id, cons_id: rowData.consultant_ID,
            recruiter: rowData.user_Name, req_id: rowData.req_ID,
            vendor_Company_ID: rowData.vendor_Company_ID, status: rowData.req_Service_Status
        })}>{rowData.submission_id}</div>
    }

    const onHide = () => {
        props.hideDialog();
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header={`Submissions for Req - ${props.req_id} (${props.job_Title})`} className="p-fluid" draggable={false} onHide={onHide}>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={tableData.tableData}
                loading={tableData.loading}
            >
                <Column field="submission_id" header="Submission ID" body={submission_id} />
                <Column field="consultant_Name" header="Consultant" />
                <Column field="user_Name" header="Recruiter" />
                <Column field="buying_Rate" header="Buying Rate" />
                <Column field="req_Service_Status_Name" header="Submission Status" body={(rowData: ISubmittals) => rowData.req_Service_Status_Name ? rowData.req_Service_Status_Name : <span className="text-cyan-700">Submitted by Recruiter</span>} />
                <Column field="submitalDate" header="Submission Date" />
            </DataTable>
            <Submission recruiter={submission.recruiter} vendor_Company_ID={submission.vendor_Company_ID} submission_id={submission.submission_id} req_id={submission.req_id} cons_id={submission.cons_id} status={submission.status} open={submission.open} hideDialog={hideSubmissionDialog} toast={props.toast} reload={props.reload} setReload={props.setReload} hideDialogP={props.hideDialog} />
        </Dialog>
    );
}